<template>
	<div>
		<h3 class="popup-tilte">Bejelentkezés</h3>
		<Login />
	</div>
</template>

<script>
import Login from '@/components/Login.vue';

export default {
	components: {
		Login,
	},
};
</script>
